<lms-breadcrumb *ngIf="scope === 'itineraries'"></lms-breadcrumb>

<lms-courses-list
  [listId]="listId"
  [courses]="itineraries"
  [client]="client"
  [options]="options"
  [selectable]="selectable"
  [bulkActions]="bulkActions"
  (courseBulkAction)="itineraryBulkActions($event)"
  (courseEvent)="onCourseEvent($event)"
>
  <lms-no-itineraries noCourses [isCreator]="user.isCreator" [clientView]="scope === 'client'"></lms-no-itineraries>

  <div owner class="lms-toolbar__selector padding-none">
    <gl-select [options]="ownerOptions" [value]="selectedOwner" (onChange)="onChangeSelectedOwner($event.detail.value)">
    </gl-select>
  </div>
  <div actions class="tools-item courses-preview-button" *lmsProfileGuard="'training.itineraries.create'">
    <gl-button
      *ngIf="scope === 'itineraries'"
      color-primary
      [text]="'actions.createItinerary' | translate"
      class="margin-left"
      (onClick)="goToCreateItinerary()"
    >
    </gl-button>
  </div>
</lms-courses-list>
<lms-change-access-itineraries
  #changeAccess
  [catalogueId]="catalogueId"
  (confirm)="onConfirmBulkAction($event)"
></lms-change-access-itineraries>
<lms-send-diploma-itineraries
  #sendDiploma
  [catalogueId]="catalogueId"
  (confirm)="onConfirmBulkAction($event)"
></lms-send-diploma-itineraries>
